import {AbstractParameter} from "parameters/AbstractParameter.js";

export default superclass => class extends superclass  {
    setupPlayable() {
        this.playingParameter = new AbstractParameter(
            "playing", this, () => [],
            {
                defaultValue: 1,
                min: 0,
                max: 1
            });
        this.registerParameter(this.playingParameter);
    }

    get playing() {
        return this.playingParameter.get();
    }
}
 
